export default __webpack_public_path__ + "static/media/PeonyOpossum.25dfeb87.png";